/**
 *
 * @author fuyg
 * @date  2020-06-04
 */

import React, { ReactElement /*, useEffect */ } from 'react'
// import { useSelector, useDispatch, shallowEqual } from 'react-redux'
import styles from './InvestorEventDetailView.module.scss'
// import { fetchData } from '../sliceName'
// import { RootState } from 'src/pages/home/store/rootReducer'
import { RouteConfigComponentProps } from 'react-router-config'
import { InvestorEventDetail } from '../../components/InvestorEventDetail'

function InvestorEventDetailView(
  props: RouteConfigComponentProps<{ eventId: string }>,
): ReactElement {
  // 获取数据
  // const dispatch = useDispatch()

  // useEffect(() => {
  // dispatch(fetchData({}))
  // }, [])

  // 绑定数据
  // const { data } = useSelector((state: RootState) => {
  // return {
  // data: state.sliceName.data,
  // }
  // }, shallowEqual)

  const { match } = props
  const { params } = match
  const { eventId } = params

  return (
    <div className={styles.container}>
      <InvestorEventDetail eventId={eventId} />
    </div>
  )
}

export default InvestorEventDetailView
